export default __webpack_public_path__ + "static/media/logo-w-beta-badge-162x28.109bc1df.svg";